import React from "react";
import { useSelector } from "react-redux";
import { useFlags } from "launchdarkly-react-client-sdk";

import { getTimeOffAllowedCountries } from "selectors/platformConfig";

function TimeoffNotAvailable() {
  const { anniversaryBasedTimeOff } = useFlags();

  const getEmployeeDetails = useSelector((state) => state.GetEmployeeDetails.getEmployeeDetails);
  const timeOffAllowedCountries = useSelector((state) => getTimeOffAllowedCountries(state, anniversaryBasedTimeOff));

  return (
    <div className="time-off-not-available">
      {!getEmployeeDetails?.payload?.timeoffFlag &&
      timeOffAllowedCountries?.includes(
        anniversaryBasedTimeOff ? getEmployeeDetails?.payload?.timeoffCountry : getEmployeeDetails?.payload?.country
      )
        ? "Time-off is disabled for you. Please contact your administrator."
        : `Time-off feature is currently only available for employees based in Pakistan. We're
      working to bring this feature for employees based in Peru soon. Meanwhile, for Peruvian employees, please continue
      following the same process as was being followed before.`}
    </div>
  );
}

export default TimeoffNotAvailable;
